import React from "react";
import { Box, Button, Checkbox, FormControlLabel, Popover, Typography } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { AUDIT_STATUS_LABEL, AUDIT_STATUSES } from "../constants";
import { AH_BORDER, AH_MUTED, AH_TEXT, blueOutlinedButtonSx } from "../theme";

const STATUS_OPTIONS = [
  AUDIT_STATUSES.DRAFT,
  AUDIT_STATUSES.ACTIVE,
  AUDIT_STATUSES.COMPLETED,
  AUDIT_STATUSES.CANCELLED,
];

const optionLabelSx = { display: "flex", mx: 0.5, my: 0 };

const FilterMenu = ({
  anchorEl,
  onOpen,
  onClose,
  selectedStatuses,
  onToggleStatus,
  onClear,
}) => {
  const activeCount = selectedStatuses.length;
  return (
    <>
      <Button
        variant="outlined"
        startIcon={<FilterListIcon sx={{ fontSize: 18 }} />}
        onClick={onOpen}
        sx={{ ...blueOutlinedButtonSx, flexShrink: 0, whiteSpace: "nowrap" }}
      >
        Filter By Status
        {activeCount > 0 ? ` (${activeCount})` : ""}
      </Button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        slotProps={{
          paper: {
            sx: {
              width: 160,
              borderRadius: "10px",
              p: 1,
              border: `1px solid ${AH_BORDER}`,
              boxShadow: "0 4px 6px -1px rgba(0,0,0,0.08), 0 2px 4px -2px rgba(0,0,0,0.06)",
              overflow: "hidden",
            },
          },
        }}
      >
        <Typography sx={{ px: 1, pt: 0.5, pb: 0.75, fontSize: 11, fontWeight: 700, color: AH_MUTED, letterSpacing: "0.04em" }}>
          STATUS
        </Typography>
        {STATUS_OPTIONS.map((status) => (
          <FormControlLabel
            key={status}
            sx={optionLabelSx}
            control={
              <Checkbox
                size="small"
                checked={selectedStatuses.includes(status)}
                onChange={() => onToggleStatus(status)}
              />
            }
            label={<Typography sx={{ fontSize: 13, color: AH_TEXT }}>{AUDIT_STATUS_LABEL[status] || status}</Typography>}
          />
        ))}
        {activeCount > 0 && (
          <Box sx={{ px: 1, pt: 1 }}>
            <Button size="small" onClick={onClear} sx={{ textTransform: "none", fontWeight: 600 }}>
              Clear filters
            </Button>
          </Box>
        )}
      </Popover>
    </>
  );
};

export default FilterMenu;
